import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Container, Button } from "@atoms";
import { HeadingWIcon, CardDownload } from "@molecules";

const MembershipBenefits = ({ heading, copy, cards, link }) => {
  const { romero } = brand;
  return (
    <div
      className={classNames("relative w-full overflow-hidden", {
        "py-12 md:py-24": romero,
      })}
    >
      <Container>
        <div className="relative">
          <HeadingWIcon
            heading={heading}
            copy={copy}
            className="mx-auto mb-12 max-w-xl lg:mb-16"
            centered
            colors={romero ? { heading: "text-blue" } : null}
          />
        </div>
        <div className="-mx-2 flex flex-wrap">
          {cards.map(card => (
            <div key={card.heading} className="mb-4 w-full px-2 sm:w-1/3">
              <CardDownload {...card} />
            </div>
          ))}
        </div>
        <div className="mt-12 flex justify-center">
          <Button
            to={link.link}
            rounded={romero}
            color={romero ? "blue" : "red"}
          >
            {link.text}
          </Button>
        </div>
      </Container>
    </div>
  );
};

MembershipBenefits.defaultProps = {};

export default MembershipBenefits;
